import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * useLatestBlogPosts
 * Returns the N most-recent posts, merging static + AI-generated results from /api/blogs.
 * Falls back silently to the supplied static list on network failure.
 */
export default function useLatestBlogPosts(staticPosts, limit = 3) {
  const [posts, setPosts] = useState(() =>
    [...staticPosts].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, limit)
  );

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/blogs`)
      .then((res) => {
        if (cancelled) return;
        const api = res.data || [];
        const bySlug = {};
        [...staticPosts, ...api].forEach((p) => { bySlug[p.slug] = p; });
        const latest = Object.values(bySlug)
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, limit);
        if (latest.length) setPosts(latest);
      })
      .catch(() => { /* keep static fallback */ });
    return () => { cancelled = true; };
    // staticPosts + limit captured on mount — they are module-level constants in practice
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return posts;
}
